<template>
    <site-img
        type="bgImg"
        class="md-calculator broker"
        :src="bgType == 'img' ? suitableImg : ''"
        :style="{ 'background-color': bgType == 'color' ? bgColor : null }"
    >
        <module-box
            class="full-space"
            :fullColumn="fullColumn"
            :topSpacing="topSpacing"
            :btmSpacing="btmSpacing"
            :mobileTopSpacing="mobileTopSpacing"
            :mobileBtmSpacing="mobileBtmSpacing"
        >
            <div v-if="title" class="mg-title" v-html="formatFontSize(title, '--mg-title-size')"></div>
            <div
                class="description-container"
                v-if="description"
                v-html="formatFontSize(description, 15)"
            ></div>

            <div class="body-content">
                <div class="cal-container">
                    <CalForm
                        :needRegister="needRegister"
                        ref="calform"
                        :advancedText="advancedText"
                        :simpleText="simpleText"
                        :payment="payment"
                        :info="calcInfo"
                        @submit="onCalSubmit"
                        @changePayment="handleChangePayment"
                    />
                </div>
                <div class="cal-result">
                    <div class="tab">
                        <div class="bottom-line"></div>
                        <div
                            :class="{ active: tab == 'payment' }"
                            @click="changeTab('payment')"
                            class="tab-item"
                        >
                            {{ $t('md-calculator.payment') }}
                        </div>
                        <div
                            :class="{ active: tab == 'schedule' }"
                            @click="changeTab('schedule')"
                            class="tab-item"
                        >
                            {{ $t('md-calculator.schedule') }}
                        </div>
                    </div>
                    <div class="tab-content payment" v-show="tab == 'payment'">
                        <div class="payment-des" v-html="paymentDes"></div>
                        <div class="result-content">
                            <ResultPie
                                :ref="(e) => onRef('resultPie', e)"
                                theme="broker"
                            />
                            <LeadForm
                                v-if="!isMobileSize"
                                :leadFormTitle="
                                    formatFontSize(leadFormTitle, 20)
                                "
                                :nameFormat="nameFormat"
                                :requirePhone="requirePhone"
                                disclaimerColor="#a0a3af"
                            />
                        </div>
                    </div>
                    <div class="tab-content schedule" v-show="tab == 'schedule'">
                        <div class="payment-des" v-html="paymentDesEst"></div>
                        <div class="result-content">
                            <ResultLine :ref="(e) => onRef('resultLine', e)" />
                            <LeadForm
                                v-if="!isMobileSize"
                                :leadFormTitle="
                                    formatFontSize(leadFormTitle, 20)
                                "
                                :nameFormat="nameFormat"
                                :requirePhone="requirePhone"
                                disclaimerColor="#a0a3af"
                            />
                        </div>
                    </div>
                    <LeadForm
                        v-if="isMobileSize"
                        :leadFormTitle="formatFontSize(leadFormTitle, 20)"
                        :nameFormat="nameFormat"
                        :requirePhone="requirePhone"
                        disclaimerColor="#a0a3af"
                    />
                </div>
            </div>
        </module-box>
    </site-img>
</template>

<script>
import Common from '../index';
import LeadForm from '../../../components/broker-lead-form.vue';
import ResultPie from '../result-pie.vue';
import ResultLine from './result-line.vue';
import CalForm from './calculator-form.vue';
import { getSplineData } from '../../../components/caculator/lib/calFormula';
export default {
    mixins: [Common],
    components: { LeadForm, ResultPie, ResultLine, CalForm },
    data: function() {
        return {
            lineOptions: {},
            tab: 'payment',
            loanTerm: 0,
            total: 0,
            monthly: 0,
            paymentRendered: false,
            scheduleRendered: false
        };
    },
    created() {
        this.loanTerm = this.payment.loanTerm;
    },
    // watch: {
    //     isMobileSize: function () {
    //         this.$refs.resultPie && this.$refs.resultPie.refresh();
    //     }
    // },
    computed: {
        paymentDes() {
            return this.$t('md-calculator.yourMortgagePayments', {
                loanTerm: this.loanTerm,
                total: this.$ft.formatDollar(this.total, true, false, '$0')
            });
        },
        paymentDesEst() {
            let payment = this.$t('md-calculator.yourMortgagePayments', {
                loanTerm: this.loanTerm,
                total: this.$ft.formatDollar(this.total, true, false, '$0')
            });
            let estimate = this.$t('md-calculator.estimatePayment', {
                monthly: this.$ft.formatDollar(this.monthly, true, false, '$0')
            });
            return payment + estimate;
        }
    },
    methods: {
        changeTab(tab) {
            this.tab = tab;
            this.$nextTick(() => {
                if (this.tab == 'payment' && !this.paymentRendered) {
                    this.$refs.calform.refresh();
                    this.paymentRendered = true;
                    return;
                }
                if (this.tab == 'schedule' && !this.scheduleRendered) {
                    this.$refs.calform.refresh();
                    this.scheduleRendered = true;
                }
            });
        },
        onCalSubmit(result, raw) {
            this.scheduleRendered = false;
            this.paymentRendered = false;

            this.loanTerm = raw.loanTerm;
            this.monthly = 0;
            Object.keys(result).forEach(key => {
                this.monthly += +result[key];
            });
            this.monthly = this.monthly.toFixed(0);
            this.total = (this.monthly * 12 * this.loanTerm).toFixed(0);
            if (this.tab == 'payment') {
                Object.keys(result).forEach(key => {
                    result[key] = (+result[key]).toFixed(0);
                });
                this.refs.resultPie?.refresh(result);
                this.paymentRendered = true;
            } else {
                let splinesData = getSplineData(
                    raw.total,
                    raw.downPaymentValue,
                    result.pi,
                    raw.loanTerm,
                    raw.interestRate / 100
                );
                this.refs.resultLine?.refresh(splinesData);
                this.scheduleRendered = true;
            }
        }
    }
};
</script>
<style lang="scss">
@import './style.scss';
</style>
